import { getCountries } from 'helpers/getCountries'
import { useAppTranslation } from 'i18n/hooks'
import { useCallback, useEffect, useState } from 'react'

export const useCountries = () => {
  const {
    i18n: { language },
  } = useAppTranslation()
  const [countries, setCountries] = useState([])
  const [loading, setLoading] = useState(false)

  const setStateCountries = useCallback(async () => {
    setLoading(true)
    const countriesData = await getCountries(language)
    const countries = Object.keys(countriesData).map(code => ({ code, label: countriesData[code] }))

    setCountries(countries)
    setLoading(false)
  }, [language])

  useEffect(() => {
    setStateCountries()
  }, [setStateCountries])

  return [countries, loading]
}
